import axios from "axios";

// Public backend URL (Railway), set at build time. Tolerates a trailing "/" or "/api"
// and a missing scheme ("x.up.railway.app" would otherwise be requested relative to the frontend).
let BASE = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "").replace(/\/api$/, "");
if (BASE && !/^https?:\/\//i.test(BASE)) {
  BASE = `https://${BASE.replace(/^\/+/, "")}`;
}
if (!BASE) {
  // Without it every request would go to the frontend host and fail with 404.
  console.error("REACT_APP_BACKEND_URL ist nicht gesetzt – API-Aufrufe werden fehlschlagen.");
}
export const API_BASE = `${BASE}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("blessing_token");
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // token invalid — clear
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/crm")) {
        localStorage.removeItem("blessing_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Ein Fehler ist aufgetreten.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export default api;
